import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import {
  IDependentValue,
  IReviewerRecommendation
} from '@publishing-engine/domain/models/submission';
import { ReviewersDisplay } from './ReviewersDisplay';
import { IReviewersFormField } from 'src/pages/Organization/public/Journal/SubmissionUpload/components/ReviewerRecommendation';

interface Props {
  value?: IDependentValue<IReviewerRecommendation[]>;
  previousValue?: IDependentValue<IReviewerRecommendation[]>;
  onClose: () => void;
  config: IReviewersFormField;
  displayLabel?: string;
}

export const ReviewersDiffModal = ({
  value,
  previousValue,
  onClose,
  config,
  displayLabel
}: Props) => {
  const label = displayLabel || config.params.labels.main;

  const zeroState = (
    <Flex padding={4} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">Was value provided?</Text>
          <Text>{previousValue?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">Value </Text>
          {!previousValue?.value ? (
            zeroState
          ) : (
            <ReviewersDisplay value={previousValue.value} />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">Was value provided?</Text>
          <Text>{value?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">Value </Text>
          {!value?.value ? zeroState : <ReviewersDisplay value={value.value} />}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
